(() => {
  'use strict';

  if (window.__femmeRecommendedExtrasPositionFixV4) return;
  window.__femmeRecommendedExtrasPositionFixV4 = true;

  const ROOT_SELECTOR = '[data-custom-product-upsell]';
  const FORM_SELECTOR = 'form[data-type="add-to-cart-form"], form.main-product-form';
  const TEMPDROP_PATH = '/products/tempdrop-fertility-monitor';
  const knownRoots = new Map();
  const knownPayments = new Map();
  let scheduledFrame = null;

  const getKey = (root) => String(root?.dataset.customProductUpsell || root?.id || '');

  const rememberRoot = (root) => {
    if (!(root instanceof Element)) return;
    const key = getKey(root);
    if (!key) return;

    const existing = knownRoots.get(key);
    if (existing && existing !== root && existing.isConnected) existing.remove();
    knownRoots.set(key, root);

    const payment = root.querySelector(`[data-custom-upsell-payment-messaging="${key}"]`);
    if (payment) knownPayments.set(key, payment);
  };

  const registerCurrentRoots = () => {
    document.querySelectorAll(ROOT_SELECTOR).forEach(rememberRoot);
  };

  const removeTempdropQvNofollow = () => {
    if (window.location.pathname !== TEMPDROP_PATH) return;

    document.querySelectorAll('a[href][rel]').forEach((anchor) => {
      if (!(anchor instanceof HTMLAnchorElement)) return;

      let url;
      try {
        url = new URL(anchor.getAttribute('href'), window.location.origin);
      } catch (_error) {
        return;
      }

      if (
        url.origin !== window.location.origin ||
        url.pathname !== TEMPDROP_PATH ||
        !url.searchParams.has('qv')
      ) {
        return;
      }

      const relTokens = (anchor.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
      if (!relTokens.some((token) => token.toLowerCase() === 'nofollow')) return;

      const cleanedTokens = relTokens.filter((token) => token.toLowerCase() !== 'nofollow');
      if (cleanedTokens.length) anchor.setAttribute('rel', cleanedTokens.join(' '));
      else anchor.removeAttribute('rel');
    });
  };

  const getProductInfo = (root) => {
    const productId = String(root?.dataset.currentProductId || '');
    const roots = Array.from(document.querySelectorAll('product-info'));

    if (productId) {
      const exact = roots.filter(
        (candidate) => String(candidate.dataset.productId || '') === productId
      );
      return (
        exact.find((candidate) => candidate.id.startsWith('MainProduct-')) ||
        exact.find((candidate) => candidate.offsetParent !== null) ||
        exact[0] ||
        null
      );
    }

    return root?.closest('product-info') || roots.find((candidate) => candidate.id.startsWith('MainProduct-')) || roots[0] || null;
  };

  const getPayment = (root, key) => {
    const selector = `[data-custom-upsell-payment-messaging="${key}"]`;
    const payment = root.querySelector(selector) || document.querySelector(selector) || knownPayments.get(key);
    if (payment) knownPayments.set(key, payment);
    return payment || null;
  };

  const getPurchaseTarget = (root) => {
    const productInfo = getProductInfo(root);
    if (!productInfo) return null;

    const forms = Array.from(productInfo.querySelectorAll(FORM_SELECTOR));
    const form =
      forms.find((candidate) =>
        candidate.querySelector('.product-form__buttons button[name="add"], .product-form__buttons .product-form__submit')
      ) || null;

    if (!form) return null;
    const buttonGroup = form.querySelector('.product-form__buttons');
    return buttonGroup ? { form, buttonGroup } : null;
  };

  const styleInlineUpsell = (root) => {
    root.style.order = '15';
    root.style.flex = '0 0 100%';
    root.style.width = '100%';
    root.style.maxWidth = '100%';
    root.style.minWidth = '0';
    root.style.margin = '0';
  };

  const clearInlineUpsellStyle = (root) => {
    ['order', 'flex', 'width', 'maxWidth', 'minWidth', 'margin'].forEach((property) => {
      root.style[property] = '';
    });
  };

  const positionRoot = (root) => {
    if (!(root instanceof Element)) return false;

    const key = getKey(root);
    if (!key) return false;

    const target = getPurchaseTarget(root);
    if (!target) return false;

    const { buttonGroup } = target;
    const payment = getPayment(root, key);
    const hasUpsells = root.dataset.hasUpsells === 'true';

    if (!hasUpsells) {
      clearInlineUpsellStyle(root);

      if (payment && payment.parentNode !== root) {
        const variantData = root.querySelector('[data-custom-upsell-main-variants]');
        if (variantData) root.insertBefore(payment, variantData);
        else root.appendChild(payment);
      }

      if (buttonGroup.nextElementSibling !== root) {
        buttonGroup.insertAdjacentElement('afterend', root);
      }

      return true;
    }

    if (payment && buttonGroup.nextElementSibling !== payment) {
      buttonGroup.insertAdjacentElement('afterend', payment);
    }

    styleInlineUpsell(root);

    if (root.parentElement !== buttonGroup) {
      buttonGroup.appendChild(root);
    }

    return true;
  };

  const repositionAll = () => {
    scheduledFrame = null;
    removeTempdropQvNofollow();
    registerCurrentRoots();
    knownRoots.forEach(positionRoot);
  };

  const scheduleReposition = () => {
    if (scheduledFrame !== null) return;
    scheduledFrame = window.requestAnimationFrame(repositionAll);
  };

  registerCurrentRoots();
  repositionAll();

  const observer = new MutationObserver(scheduleReposition);
  const observerOptions = { childList: true, subtree: true };
  if (window.location.pathname === TEMPDROP_PATH) {
    observerOptions.attributes = true;
    observerOptions.attributeFilter = ['href', 'rel'];
  }
  observer.observe(document.body || document.documentElement, observerOptions);

  [0, 120, 400, 900, 1600, 2500, 4000].forEach((delay) => {
    window.setTimeout(scheduleReposition, delay);
  });

  document.addEventListener('shopify:section:load', scheduleReposition);
  document.addEventListener('shopify:section:reorder', scheduleReposition);
  document.addEventListener('variant:changed', scheduleReposition);
  document.addEventListener('sealsubs:subscription_widget_created', scheduleReposition);
  document.addEventListener('sealsubs:selling_plan_changed', scheduleReposition);
  window.addEventListener('pageshow', scheduleReposition);
})();
